var _path, _path2, _path3, _rect, _path4, _path5, _rect2, _path6, _path7, _rect3, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProductListPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 135,
    viewBox: "0 0 201 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.422 97.1837C200.422 94.8677 198.544 92.9902 196.228 92.9902H12.8025C10.4865 92.9902 8.60895 94.8677 8.60895 97.1837C8.60895 99.4998 10.4865 101.377 12.8025 101.377H37.3892C39.7053 101.377 41.5828 103.255 41.5828 105.571C41.5828 107.887 39.7053 109.764 37.3892 109.764H32.4711C30.1551 109.764 28.2775 111.642 28.2775 113.958C28.2775 116.274 30.1551 118.151 32.4711 118.151H47.0666C49.3827 118.151 51.2602 120.029 51.2602 122.345C51.2602 124.661 49.3827 126.539 47.0666 126.539H40.5356C38.2196 126.539 36.3421 128.416 36.3421 130.732C36.3421 133.048 38.2196 134.926 40.5356 134.926H140.429C142.745 134.926 144.622 133.048 144.622 130.732C144.622 128.416 142.745 126.539 140.429 126.539H118.325C116.009 126.539 114.132 124.661 114.132 122.345C114.132 120.029 116.009 118.151 118.325 118.151H183.168C185.484 118.151 187.362 116.274 187.362 113.958C187.362 111.642 185.484 109.764 183.168 109.764H161.474C159.158 109.764 157.28 107.887 157.28 105.571C157.28 103.255 159.158 101.377 161.474 101.377H196.228C198.544 101.377 200.422 99.4998 200.422 97.1837ZM64.7095 126.539C62.3935 126.539 60.516 124.661 60.516 122.345C60.516 120.029 62.3935 118.151 64.7095 118.151H78.4864C80.8024 118.151 82.6799 120.029 82.6799 122.345C82.6799 124.661 80.8024 126.539 78.4864 126.539H64.7095Z",
    fill: "#F1FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.829 130.732C149.829 128.416 151.706 126.539 154.022 126.539H173.981C176.297 126.539 178.175 128.416 178.175 130.732C178.175 133.048 176.297 134.926 173.981 134.926H154.022C151.706 134.926 149.829 133.048 149.829 130.732Z",
    fill: "#F1FAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9335 113.958C18.9335 111.642 17.056 109.764 14.7399 109.764H4.61542C2.29939 109.764 0.421875 111.642 0.421875 113.958C0.421875 116.274 2.29939 118.151 4.61542 118.151H14.7399C17.056 118.151 18.9335 116.274 18.9335 113.958Z",
    fill: "#F1FAFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.3516,
    y: 46.8359,
    width: 50.4567,
    height: 55.5023,
    fill: "#93CBF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3521 46.8359H99.8088L85.9332 31.6989H35.4766L49.3521 46.8359Z",
    fill: "#0071BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.353 46.8359V65.1265H31.0625L49.353 46.8359Z",
    fill: "#0071BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.8125,
    y: 46.8359,
    width: 58.0252,
    height: 55.5023,
    fill: "#0071BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8125 46.8359H157.838L170.452 70.8029H112.427L99.8125 46.8359Z",
    fill: "#93CBF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8125 46.8359H157.838L170.452 35.4832H112.427L99.8125 46.8359Z",
    fill: "#8BBFE2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8672,
    y: 57.5059,
    width: 25.8065,
    height: 6.45161,
    fill: "#0071BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1328 9.31445L49.5856 19.1584",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7734 1.05469L62.331 13.5524",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.586 9.31445L152.133 19.1584",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.945 1.05469L139.388 13.5524",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProductListPlaceholder);
export default __webpack_public_path__ + "static/media/noProductListPlaceholder.5c4d42505c9b410eb171bc184a194e56.svg";
export { ForwardRef as ReactComponent };